import { SerializedStyles } from "@emotion/react";
import { Ref, memo, useCallback } from "react";
import { useNoSubmit } from "src/apps/AppFlow/pages/hooks";
import { styles } from "src/apps/AppFlow/pages/styles";
import { FormFlowPage, TextInput } from "src/components";
import { GeneralIncomeDetailsValue } from "src/types/Application";

export interface GeneralIncomeDetailsProps {
  onChange: (value: GeneralIncomeDetailsValue) => void;
  value?: GeneralIncomeDetailsValue;

  focusRef?: Ref<HTMLInputElement>;
  onNext: () => void;
  onBack: () => void;
  style?: SerializedStyles;
}

const GeneralIncomeDetails = ({
  onNext,
  onBack,
  style,
  focusRef,
  value,
  onChange,
  ...props
}: GeneralIncomeDetailsProps) => {
  const validate = useCallback(() => value?.income !== undefined, [value]);
  const { handleNext, nextDisabled } = useNoSubmit({ onNext, validate });

  const handleChangeIncome = useCallback(
    (income?: string) => {
      onChange({
        ...value,
        income,
      });
    },
    [onChange, value]
  );

  return (
    <FormFlowPage
      {...props}
      title="What is your income?"
      description="For your income, give an estimate of the total amount of income from this source you receive annually."
      onNext={handleNext}
      onBack={onBack}
      style={style}
      nextDisabled={nextDisabled}
    >
      <TextInput
        ref={focusRef}
        style={styles.topInput}
        name="income"
        label="Total annual income"
        value={value?.income || ""}
        min={0}
        onChange={handleChangeIncome}
        maskOptions={{
          rightAlign: false,
          alias: "currency",
          prefix: "$ ",
          jitMasking: false,
          digits: 0,
        }}
      />
    </FormFlowPage>
  );
};

export default memo(GeneralIncomeDetails);
